import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'WeployDesignLanguage/buttons/Button';
import Avatar from 'LegacyWeployDesignLanguage/Avatar';
import moment from 'moment-timezone';
import Table from '../common/table';
import { StyledTableCell } from './DashboardWeployeesList';

const StyledInitials = styled.div`
  color: ${props => props.theme.colors.text.primaryOnDark};
  font-size: 32px;
  letter-spacing: 2px;
  line-height: 0;
`;

function displayDate(date) {
  return moment(date).format('DD/MM/YYYY');
}

function renderFinishDate(finishDate, isFinishingSoon = false) {
  return isFinishingSoon ? <strong>{finishDate}</strong> : finishDate;
}

const DashboardWeployeesListTableRow = ({ position, onExtendButton }) => (
  <Table.Row>
    <StyledTableCell>
      <Avatar
        size={Avatar.EXTRA_SMALL}
        src={position.weployeeProfileImageUrl}
        text={
          <StyledInitials>
            {position.weployeeInitials}
          </StyledInitials>
        }
      />
    </StyledTableCell>
    <StyledTableCell>{position.weployeeName}</StyledTableCell>
    <StyledTableCell>{displayDate(position.startTime)}</StyledTableCell>
    <StyledTableCell>
      {renderFinishDate(displayDate(position.finishTime), position.isFinishingSoon)}
    </StyledTableCell>
    <StyledTableCell>
      { position.extendable &&
        <Button onClick={() => onExtendButton(position.jobId, position.id)}>Extend</Button>
      }
    </StyledTableCell>
  </Table.Row>
);

DashboardWeployeesListTableRow.propTypes = {
  position: PropTypes.shape({
    id: PropTypes.string.isRequired,
    jobId: PropTypes.string.isRequired,
    weployeeProfileImageUrl: PropTypes.string,
    weployeeInitials: PropTypes.string.isRequired,
    startTime: PropTypes.string,
    finishTime: PropTypes.string,
    weployeeName: PropTypes.string.isRequired,
    extendable: PropTypes.bool.isRequired,
    isFinishingSoon: PropTypes.bool.isRequired,
  }),
  onExtendButton: PropTypes.func,
};

DashboardWeployeesListTableRow.defaultProps = {
  position: {
    weployeeProfileImageUrl: null,
    startTime: null,
    finishTime: null,
  },
  onExtendButton: () => {},
};

export default DashboardWeployeesListTableRow;
